import Yup from '@fourthwall/utils/dist/yup';
import { variantPriceSchema, variantSkuSchema, variantWeightSchema, } from '../../../../../validators/productValidatorSchema';
export const productVariantValidationSchema = Yup.object().shape({
    price: variantPriceSchema,
    weight: variantWeightSchema,
    sku: variantSkuSchema,
});
